export default __webpack_public_path__ + "static/media/logoApp.725445cf.svg";